import Contact from "../components/Contact";

export default function ContactPage() {
  return (
    <div className="pt-24 sm:pt-28">
      <Contact />
    </div>
  );
}
